import { JsonDecoder } from 'ts.data.json';
import { SupplementalFile, supplementalFileDecoder } from '@trade-platform/ui-shared';

export const DocumentTypesDecoder = JsonDecoder.array<SupplementalFile>(
    supplementalFileDecoder,
    'SupplementalFile[]'
);
